import { isNull, isUndefined } from "lodash";

export type StorageUpdateEventDetail = { key: string; value: string };
export const STORAGE_UPDATE_EVENT_NAME = "storageUpdate";
const storage = {
  get: <T>(key: string): T | null => {
    const item = localStorage.getItem(key);
    if (!item) return null;

    try {
      return JSON.parse(item);
    } catch (e) {
      return null;
    }
  },
  patch: <T>(key: string, value: Partial<T>, defaultValue: T) => {
    const item = storage.get<T>(key);
    storage.set<T>(key, { ...(item ?? defaultValue), ...value });
  },
  remove: (key: string) => {
    localStorage.removeItem(key);
  },
  set: <T>(key: string, value: T) => {
    if (isNull(value) || isUndefined(value)) return;

    const event = new CustomEvent(STORAGE_UPDATE_EVENT_NAME, {
      detail: { key, value: JSON.stringify(value) }
    });
    window.dispatchEvent(event);

    localStorage.setItem(key, JSON.stringify(value));
  }
};
export default storage;
